export default {"src":"/_next/static/media/VST.f66aa14e.svg","height":18,"width":18};